export default __webpack_public_path__ + "static/media/students.24f06ebc.jpg";